import { render } from "./alertState.vue?vue&type=template&id=6da15da8"
import script from "./alertState.vue?vue&type=script&lang=js"
export * from "./alertState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__